import { MeterBarSegment } from '../../../shared/components/meter-bar-segment/MeterBarSegment.js';
import { getSegmentWidth } from '../../../shared/utils/get-segment-width.js';
import { useMeterBarChartData } from '../../context/MeterBarChartDataContext.js';

export const MeterBarChartSegment = () => {
  const { color, value, min, max, width } = useMeterBarChartData();

  const segmentWidth = getSegmentWidth(value, min, max, width);

  return <MeterBarSegment color={color} width={segmentWidth} />;
};

MeterBarChartSegment['displayName'] = 'MeterBarChartSegment';
